import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  coordinateModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import AddressModal from './AddressModal';
import { timeData } from '@/data/timeData';
import { Map, MapMarker } from 'react-kakao-maps-sdk';
import { GetFacilitiesDtoRx } from '@/sdk/data-contracts';
import {
  deviceAddFacilitiesRecoil,
  deviceSelectFacilityRecoil,
  deviceSelectFacilityProps,
} from '@/atom/DeviceAtom';

declare global {
  interface Window {
    kakao: any;
  }
}

interface Coordinate {
  lat: number;
  lng: number;
}

interface CoordinateModalProps {
  addFacilities?: GetFacilitiesDtoRx;
  facilitiesName: string;
  facilitiesAddress: string;
  latitude: string;
  longitude: string;
  onCoordinateSelect: (coordinate: Coordinate) => void;
  modifyFacility?: deviceSelectFacilityProps;
}

const CoordinateModal = ({
  addFacilities,
  facilitiesName,
  facilitiesAddress,
  latitude,
  longitude,
  onCoordinateSelect,
  modifyFacility,
}: CoordinateModalProps) => {
  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setCoordinateModalState = useSetRecoilState(coordinateModalRecoil);

  const [deviceAddFacilitiesState, setDeviceAddFacilitiesState] =
    useRecoilState(deviceAddFacilitiesRecoil);
  const [deviceSelectFacilityState, setDeviceSelectFacilityState] =
    useRecoilState(deviceSelectFacilityRecoil);

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [center, setCenter] = useState({ lat: 33.450701, lng: 126.570667 });

  const geocodeAddress = (address: string) => {
    const kakao = window.kakao;
    if (!kakao || !kakao.maps) {
      console.error('Kakao Maps API가 로드되지 않았습니다.');
      return;
    }
    const geocoder = new kakao.maps.services.Geocoder();
    geocoder.addressSearch(address, (result: any, status: any) => {
      if (status === kakao.maps.services.Status.OK) {
        const newCenter = {
          lat: parseFloat(result[0].y),
          lng: parseFloat(result[0].x),
        };
        setCenter(newCenter);
      } else {
      }
    });
  };

  useEffect(() => {
    if (latitude === '' || longitude === '') {
      if (addFacilities) {
        geocodeAddress(addFacilities.address);
        setName(addFacilities.name);
        setAddress(addFacilities.address);
      }
    } else {
      setName(facilitiesName);
      setAddress(facilitiesAddress);
      setCenter({
        lat: Number(latitude),
        lng: Number(longitude),
      });
    }
  }, []);

  return (
    <>
      <ModalType1 width={1000}>
        <div className="title-box flex aic jcsb">
          <h1>위치 지정</h1>
          <button
            className="x-btn img-box"
            onClick={() => setCoordinateModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>시설명</th>
                      {/* {modifyFacility ? (
                        <td>{modifyFacility?.facilityName}</td>
                      ) : (
                        <td>{deviceAddFacilitiesState?.name}</td>
                      )} */}
                      <td>{name}</td>
                      <th>주소</th>
                      {/* {modifyFacility ? (
                        <td>{modifyFacility?.facilityAddress}</td>
                      ) : (
                        <td>{deviceAddFacilitiesState?.address}</td>
                      )} */}
                      <td>{address}</td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
              <CoordinateText>
                선택한 위치의 위도는 {center.lat} 이고, 경도는&nbsp;
                {center.lng} 입니다.
              </CoordinateText>
              <MapBox>
                <Map
                  center={center}
                  style={{ width: '100%', height: '100%' }}
                  level={3}
                  draggable={true}
                  zoomable={true}
                  onClick={(_target, mouseEvent) => {
                    const clickedLat = mouseEvent.latLng.getLat();
                    const clickedLng = mouseEvent.latLng.getLng();
                    setCenter({ lat: clickedLat, lng: clickedLng });
                  }}
                >
                  <MapMarker position={center}></MapMarker>
                </Map>
              </MapBox>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setCoordinateModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4
              type="button"
              onClick={() => {
                onCoordinateSelect(center);
                setCoordinateModalState(false);
              }}
            >
              저장
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default CoordinateModal;

const CoordinateText = styled.p`
  box-sizing: border-box;
  padding: 16px 20px 24px 20px;
  font-size: 16px;
  font-weight: 500;
  color: #444;
`;

export const MapBox = styled.div`
  width: 100%;
  height: 480px;
  border-radius: 12px;
  overflow: hidden;
`;
